import React, { useEffect, useState } from "react";
import {Grid, Card, CardContent} from "@mui/material"
import Container from "@mui/material/Container"
import CardMedia from '@mui/material/CardMedia';
import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css"; // Specify weight and style

const Hero2 = () => {
  
  const [webinar, setWebinar] = useState([])


  useEffect(() => {
    const fetchData = async ()=> {
    const AIRTABLE_TOKEN = process.env.REACT_APP_AIRTABLE_TOKEN_WEBINAR;
    const requestUrl = "https://api.airtable.com/v0/";
    const baseId = "appOpnlaeWhYPqlWu";
    const tableId = "tblto7cTDRk280bFo"
    const options = {
        method: "GET",
        headers: {
            authorization: `Bearer ${AIRTABLE_TOKEN}`
        }};
      const res = await fetch(`${requestUrl}${baseId}/${tableId}`, options)
      const data = await res.json()
      setWebinar(data.records)
      console.log(data)
    } 
      fetchData()  
  },[])

  return (
    <div>
    <Container maxWidth="xl">
      <center> <p style={{fontFamily:"poppins",fontWeight:"semibold"}} class="max-w-lg text-2xl font-semibold leading-loose text-gray-900">Previous <span class="max-w-lg text-2xl font-semibold leading-loose text-blue-700">Webinars</span></p></center>
      <br/>
      <Grid container spacing={5}>
         {webinar.map((a,index)=> (
          <Grid className="duration-500 hover:scale-105" item xs={12} sm={4} ms={4} key={index}>
            <a href={a.fields.Link}>
            <Card sx={{ maxWidth: 445,borderRadius:'10px',borderColor:"grey",borderWidth:"1px",boxShadow:"3xl"}}>
      <CardMedia
        sx={{ height: 490}}
        image={a.fields.Photo?.[0].url}
      />
      <CardContent>
      <time class="block mb-2 text-sm font-normal leading-none text-gray-400" style={{fontFamily:"poppins",fontWeight:"semibold"}}>{a.fields.Date}</time>
        <p class="max-w-lg text-xl font-medium leading-snug text-gray-900" style={{fontFamily:"poppins",fontWeight:"semibold"}}>
        {a.fields.Name}
        </p>
      </CardContent>
      <a href={a.fields.Link} style={{width:"180px"}} type="button" class="text-white text-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">View Webinar</a>
    </Card>
    </a>
          </Grid>
        ))}
      </Grid>
    </Container>
   <br/>
    </div>
  )
}
export default Hero2
